import React from "react";
import useFetch from "../Components/FetchHook";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Avatar from 'react-avatar';
import ReactLoading from 'react-loading';
import useFetchWithAuthorization from "../Apis/useFetchWithAuthorization";

const ProfilePage = () => {
const navigate = useNavigate();
  const { data, loading, error } = useFetchWithAuthorization("https://campus-closet-server.vercel.app/profile");
  // User data (replace with actual user data)
  const user = {
    name: "Justus Gitau",
    email: "jgathiru02@gmail.com",
    address: "***-****, Eldoret, KENYA",
    // address: "2500-30100, Eldoret, KENYA",
    phoneNumber: "+254** *** ***",
    avatar: "Justoe.jpg", // Path to the user's avatar image
  };
   // Handle the error state here (e.g., show an error message)
   useEffect(() => {
    if (error) {
      console.log("Error:", error);
    }
  }, [error]);

  if (error && error === "Unauthorized") {
    return(
    <div style={{ height: `calc(100vh - 100px)` }} className=" flex justify-center">
      <div>
        <h1>Unauthorized Access</h1>
        <button onClick={()=>navigate('/login')} className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`} >Login</button>
      </div>
  </div>)
  }

  return (
    <div style={{ minHeight: "calc(100vh - 120px)" }} className="container mx-auto">
      {data ? (<div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10">
        <div className="flex items-center justify-center">
          {/* <img
            className="w-20 h-20 rounded-full object-cover"
            src={require(`../photos/${user.avatar}`)}
            alt="User Avatar"
          /> */}
          <Avatar className="w-20 h-20 rounded-full" name={data.user.name} />
        </div>
        <h2 className="text-2xl font-bold mt-4 text-center">{data.user.name}</h2>
        <p className="text-gray-500 text-sm text-center">{data.user.email}</p>
        <div className="mt-6">
          <h3 className="text-lg font-bold">Personal Information</h3>
          <p className="">Check back later to complete your profile</p>
          <div className="mt-4">
          <p>
                <span className="font-bold">Address: </span>
                {data.user.address || "NA"}
              </p>
              <p>
                <span className="font-bold">Phone Number: </span>
                {data.user.Phone_Number || "NA"}
              </p>
              <p>
                <span className="font-bold">Bio: </span>
                {data.user.bio || "NA"}
              </p>
              
          </div>
        </div>
      </div>): loading ?( 
       <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
          <p>Loading...
          <ReactLoading type="spinningBubbles" color="#444654" height={'80px'} width={'80px'} />
          </p>
        </div>
      ):(
        <div className="max-w-md mx-auto bg-white shadow-md rounded-md p-6 mt-10 flex justify-center">
        <p>Failed to fetch your profile😢</p>
      </div>
      )
      }
    </div>
  );
};

export default ProfilePage;
